<div class="flex justify-content-center">
  <p-chart
    type="bar"
    [data]="weatherAtSeaChartData"
    [options]="weatherAtSeaChartOptions"
    [plugins]="weatherAtSeaChartPlugins"
    style="height: 128px; max-width: 100%"></p-chart>
</div>
